import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  return (
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label>From</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label>To</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default DateRangePicker;
